import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import * as Constant from '../Constant';
import Skeleton from 'react-loading-skeleton';
import './CourseDetails.css';

function CourseDetails() {
    const [course, setCourse] = useState({
        course_name: '',
        course_title: '',
        price: '',
        hours: '',
        image: '',
        description: '',
        syllabus: []
    });
    const [isLoading, setIsLoading] = useState(true);

    const { slug } = useParams();

    useEffect(() => {
        getCourseDetails();
    }, [slug]);

    const getCourseDetails = async () => {
        setIsLoading(true);
       
        await fetch(`${Constant.getCourseDetails}/${slug}`, {
            method: 'GET'
        })
        .then(response => response.json())
        .then(data => {
            setCourse({
                course_name: data.data.course_name || '',
                course_title: data.data.course_title || '',
                price: data.data.price || '',
                hours: data.data.hours || '',
                image: data.data.image || '',
                description: data.data.description || 'No description available',
                syllabus: data.data.syllabus || []
            });
            setIsLoading(false);
        })
        .catch(error => {
            console.error('Error fetching course details:', error);
            setIsLoading(false);
        });
    };

    const renderDescription = () => {
        return { __html: course.description };
    };

    return (
        <div className="course-details-container">
            {/* Fixed Enrollment Button */}
            {!isLoading && (
                <div className="fixed-enroll-container">
                    <button className="enroll-button">
                        Enroll Now - £{course.price}
                    </button>
                </div>
            )}

            {/* Hero Section */}
            <section className="course-hero">
                <div className="hero-overlay"></div>
                <div className="hero-content">
                    {isLoading ? (
                        <Skeleton height={60} width={300} />
                    ) : (
                        <h1 className="hero-title">{course.course_name}</h1>
                    )}
                    {isLoading ? (
                        <Skeleton height={20} width={200} />
                    ) : (
                        <p className="hero-subtitle">{course.course_title}</p>
                    )}
                </div>
            </section>

            {/* Main Content */}
            <div className="container course-main-content">
                {/* Course Image */}
                <div className="full-width-image-section">
                    {isLoading ? (
                        <Skeleton height={400} />
                    ) : (
                        <img 
                            src={course.image} 
                            alt={course.course_name} 
                            className="course-main-image"
                        />
                    )}
                </div>

                {/* Course Meta Info */}
                <div className="course-meta-container">
                    {isLoading ? (
                        <>
                            <Skeleton height={20} width={100} />
                            <Skeleton height={20} width={100} />
                        </>
                    ) : (
                        <>
                            <div className="meta-item">
                                <span className="meta-label">Duration:</span>
                                <span className="meta-value">{course.hours}</span>
                            </div>
                            <div className="meta-item">
                                <span className="meta-label">Price:</span>
                                <span className="meta-value">£{course.price}</span>
                            </div>
                        </>
                    )}
                </div>

                {/* Full Width Description */}
                <div className="full-width-description">
                    <h2 className="section-title">Course Description</h2>
                    {isLoading ? (
                        <>
                            <Skeleton count={5} />
                            <Skeleton count={3} />
                        </>
                    ) : (
                        <div 
                            className="description-content"
                            dangerouslySetInnerHTML={renderDescription()}
                        />
                    )}
                </div>

                {/* Course Syllabus */}
                {course.syllabus && course.syllabus.length > 0 && (
                    <div className="full-width-syllabus">
                        <h2 className="section-title">Course Syllabus</h2>
                        {isLoading ? (
                            <Skeleton count={5} height={30} />
                        ) : (
                            <ul className="syllabus-list">
                                {course.syllabus.map((item, index) => (
                                    <li key={index} className="syllabus-item">
                                        <span className="syllabus-item-number">{index + 1}.</span>
                                        <span className="syllabus-item-text">{item}</span>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}

export default CourseDetails;